import {
  contactDataCreationObject,
  contactComunicationDataCreationObject,
  contactPersonalDataCreationObject,
  contactSocialDataCreationObject,
} from "../Data/ContactWrappers";
import axiosInstance from "../../../Shared/Utils/axiosInstance";
import {
  ContactApi,
  ContactComunicationApi,
  ContactPersonalDataApi,
  ContactSocialDataApi,
} from "../../../Shared/Constants/api";
import { parseResponseError } from "../../../Shared/Utils/errorUtils";

export const createContactApi = async (data) => {
  try {
    let response = await axiosInstance.post(
      `${ContactApi}/all`,
      contactDataCreationObject(data)
    );

    return response.data;
  } catch (error) {
    return parseResponseError(error);
    // throw error; // Re-throw error for further handling if needed
  }
};

export const createContactPersonalDataApi = async (data) => {
  try {
    let response = await axiosInstance.post(
      `${ContactPersonalDataApi}`,
      contactPersonalDataCreationObject(data)
    );

    return response.data;
  } catch (error) {
    return parseResponseError(error);
    // throw error; // Re-throw error for further handling if needed
  }
};

export const createContactSocialDataApi = async (data) => {
  try {
    let response = await axiosInstance.post(
      `${ContactSocialDataApi}`,
      contactSocialDataCreationObject(data)
    );

    return response.data;
  } catch (error) {
    return parseResponseError(error);
    // throw error; // Re-throw error for further handling if needed
  }
};

export const createContactComunicationDataApi = async (data) => {
  try {
    let response = await axiosInstance.post(
      `${ContactComunicationApi}`,
      contactComunicationDataCreationObject(data)
    );

    return response.data;
  } catch (error) {
    return parseResponseError(error);
    // throw error; // Re-throw error for further handling if needed
  }
};
